export interface NetfaceIntegrationAgentSource {
  assigned_agent_id?: string | null;
  config?: Record<string, unknown> | null;
}

export function parseLinkedAgentIdsFromConfig(
  config: Record<string, unknown> | null | undefined,
): string[] {
  const raw = config?.linked_agent_ids;
  if (!Array.isArray(raw)) return [];
  const ids: string[] = [];
  for (const item of raw) {
    if (typeof item === "string" && item.trim()) ids.push(item.trim());
  }
  return ids;
}

export function resolveNetfaceLinkedAgentIds(
  integration: NetfaceIntegrationAgentSource | null | undefined,
): string[] {
  if (!integration) return [];
  const ids = new Set<string>();
  if (integration.assigned_agent_id) ids.add(integration.assigned_agent_id);
  for (const id of parseLinkedAgentIdsFromConfig(integration.config)) {
    ids.add(id);
  }
  return [...ids];
}

export function isAgentUsingNetfaceIntegration(
  agentId: string | null | undefined,
  integration: NetfaceIntegrationAgentSource | null | undefined,
): boolean {
  if (!agentId) return false;
  return resolveNetfaceLinkedAgentIds(integration).includes(agentId);
}
